export default "__VITE_ASSET__BTTTaKYo__"